import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';

const NoticePagination = (props) => {
  const {totalPage, nowPage, prevFn, nextFn} = props;
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <Button onClick={prevFn}>{t('main.notice.prevPage')}</Button>
      <Page>{nowPage}/{totalPage}</Page>
      <Button onClick={nextFn}>{t('main.notice.nextPage')}</Button>
    </TopLevelWrapper>
  )
}

export default NoticePagination;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 12px;
  margin-left: 8px;
  transition: all 0.3s ease-in-out;
`;

const Button = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.line};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.text};
    }
  }
`;

const Page = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;